var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30046 0.980029L9.30046 9.30003L0.980457 9.30003C0.794805 9.30003 0.61676 9.37378 0.485483 9.50505C0.354208 9.63633 0.280458 9.81438 0.280458 10C0.280458 10.1857 0.354208 10.3637 0.485483 10.495C0.61676 10.6263 0.794805 10.7 0.980457 10.7L9.30046 10.7L9.30046 19.02C9.30046 19.2057 9.37421 19.3837 9.50548 19.515C9.63676 19.6463 9.81481 19.72 10.0005 19.72C10.1861 19.72 10.3642 19.6463 10.4954 19.515C10.6267 19.3837 10.7005 19.2057 10.7005 19.02L10.7005 10.7L19.0205 10.7C19.2061 10.7 19.3842 10.6263 19.5154 10.495C19.6467 10.3637 19.7205 10.1857 19.7205 10C19.7205 9.81438 19.6467 9.63633 19.5154 9.50505C19.3842 9.37378 19.2061 9.30003 19.0205 9.30003L10.7005 9.30003L10.7005 0.980029C10.7005 0.794377 10.6267 0.616329 10.4954 0.485054C10.3642 0.353778 10.1861 0.280029 10.0005 0.280029C9.81481 0.280029 9.63676 0.353778 9.50548 0.485054C9.37421 0.616329 9.30046 0.794377 9.30046 0.980029Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.93da043e9cb9d080468747c2dc689f96.svg";
export { ForwardRef as ReactComponent };